import * as React from 'react';
import md5 from 'md5';

const AVATAR_SIZE = 90;

export const Avatar = (props) => {
  const src = props.url
    ? 'http://www.akutbolig.dk/cache/' + props.url
    : `//www.gravatar.com/avatar/${md5(props.email)}?d=mm&amp;r=g&amp;s=${AVATAR_SIZE}`;

  return (
    <div style={{ position: 'relative', ...(props.style || {}) }}>
      <img
        style={{ display: 'block', borderRadius: ' 50%' }}
        height={AVATAR_SIZE}
        src={src}
        alt="Avatar"
        onLoad={() => {
          URL.revokeObjectURL(src);
        }}
      />
    </div>
  );
};
